<script lang="ts">
  import Testimonial from '$components/testimonial.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import type { TestimonialStoryblok } from '$types/bloks';

  export let block: TestimonialStoryblok;
</script>

<section class="px-2 py-12 lg:px-8 lg:py-16">
  <div class="container isolate mx-auto" use:storyblokEditable={block}>
    <Testimonial {block} />
  </div>
</section>
